import { render, staticRenderFns } from "./AHome.vue?vue&type=template&id=32d126ce&scoped=true"
import script from "./AHome.vue?vue&type=script&lang=js"
export * from "./AHome.vue?vue&type=script&lang=js"
import style0 from "./AHome.vue?vue&type=style&index=0&id=32d126ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d126ce",
  null
  
)

export default component.exports